export default __webpack_public_path__ + "static/media/Shepherd.aed86e50.png";